import { Flex } from '@chakra-ui/react';
import { MotionBox } from './UiElements';

const CardProps = {
    w: '367px',
    minW: '240px',
    h: '100%',
    mr: '16px',
    my: 'auto',
    bg: 'groupBg',
    rounded: '18px'
};

const GroupsSkeleton = () => {
    return (
        <MotionBox
            display="flex"
            m="20px 0 0"
            h="calc(100vh - 87px)"
            overflowX="auto"
            w="calc(100vw - 72px)"
            p="0 0 16px 24px"
            pos="relative"
            initial={{ opacity: 0 }}
            animate={{
                opacity: 1,
                transition: { delay: 0.5, duration: 0.25, ease: 'easeInOut' }
            }}
        >
            <MotionBox
                animate={{
                    opacity: [0.5, 1, 0.5, 1, 0.5],
                    transition: {
                        duration: 2.75,
                        ease: 'easeInOut',
                        repeatType: 'loop',
                        repeat: 8
                    }
                }}
                {...CardProps}
            />
            <MotionBox
                animate={{
                    opacity: [0.4, 0.85, 0.4, 0.85, 0.4],
                    transition: {
                        duration: 2.75,
                        ease: 'easeInOut',
                        repeatType: 'loop',
                        delay: 0.3,
                        repeat: 8
                    }
                }}
                {...CardProps}
            />
            <MotionBox
                animate={{
                    opacity: [0.3, 0.6, 0.3, 0.6, 0.3],
                    transition: {
                        duration: 2.75,
                        ease: 'easeInOut',
                        repeatType: 'loop',
                        delay: 0.6,
                        repeat: 8
                    }
                }}
                {...CardProps}
            />
            <MotionBox
                animate={{
                    opacity: [0.2, 0.55, 0.2, 0.55, 0.2],
                    transition: {
                        duration: 2.75,
                        ease: 'easeInOut',
                        repeatType: 'loop',
                        delay: 0.9,
                        repeat: 8
                    }
                }}
                {...CardProps}
            />
        </MotionBox>
    );
};

export default GroupsSkeleton;
